import { Route, Routes } from 'react-router'
import App from './App'
import { Authenticated } from './components/Authenticated'
import NotFound from './components/NotFound'
import ReviewPlanQuote from './pages/dashboard/subscription/ReviewPlanQuote'
import Plan from './pages/dashboard/subscription/Plan'
import Dashboard from './pages/dashboard/Dashboard'
import Subscription from './pages/dashboard/subscription/Subscription'
import Pets from './pages/dashboard/pets/Pets'
// import Pet from './pages/dashboard/pets/Pet'
import DashboardLayout from './pages/dashboard/DashboardLayout'
import Login from './pages/auth/Login'
import PetLayout from './pages/dashboard/pets/PetLayout'
import Settings from './pages/dashboard/settings/Settings'
import Addresses from './pages/dashboard/settings/Addresses'
import Orders from './pages/dashboard/settings/Orders'
import OrderDetailPage from './pages/dashboard/settings/OrderDetail'
import PaymentMethods from './pages/dashboard/settings/PaymentMethods'
import PetSection from './pages/dashboard/pets/PetSection'
import Redirect from './components/Redirect'

export const Router = () => {
	return (
		<Routes>
			<Route path="/" element={<App />}>
				<Route path="login" element={<Login />} />
				<Route path="/" element={<Authenticated />}>
					<Route element={<DashboardLayout />}>
						<Route index element={<Dashboard />} />
						<Route path="pets">
							<Route index element={<Pets />} />
							<Route path=":id" element={<PetLayout />}>
								{/* <Route index element={<Pet />} /> */}
								<Route index element={<Redirect url="/pets/info" />} />
								<Route path=":section" element={<PetSection />} />
								<Route path="edit" />
							</Route>
						</Route>
						<Route path="subscription">
							<Route index element={<Subscription />} />
							<Route path=":plan" element={<Plan />} />
							<Route path="review">
								{/* <Route index element={<PlanReview />} /> */}
								<Route path=":quote" element={<ReviewPlanQuote />} />
							</Route>
							<Route path="select" />
						</Route>
						<Route path="settings">
							<Route index element={<Settings />} />
							<Route path="payment-methods">
								<Route index element={<PaymentMethods />} />
								<Route path=":id">
									<Route path="edit" />
								</Route>
								<Route path="new" />
							</Route>
							<Route path="orders">
								<Route index element={<Orders />} />
								<Route path=":id" element={<OrderDetailPage />} />
							</Route>
							<Route path="change-password" />
							<Route path="addresses">
								<Route index element={<Addresses />} />
								<Route path=":id" />
								<Route path="new" />
							</Route>
						</Route>
					</Route>
				</Route>
				<Route path="*" element={<NotFound />} />
			</Route>
		</Routes>
	)
}
